import Axios from "axios";
import {
  SET_PRODUCTION_COLOR_LIST,
  UNSET_PRODUCTION_COLOR_LIST
} from "@/store/mutation-types";
import { colorResource } from "@/store/api";

// Initial State
const state = {
  getProductionColorList: [],
};

// Getters
const getters = {
  getProductionColorList(state) {
    return state.getProductionColorList;
  },
};

// Mutations
const mutations = {
  [SET_PRODUCTION_COLOR_LIST](state, data) {
    state.getProductionColorList = data;
  },
  [UNSET_PRODUCTION_COLOR_LIST](state) {
    state.getProductionColorList = [];
  },
};

// Actions
const actions = {
  // GET LIST
  getProductionColorList({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(colorResource)
        .then((response) => {
          commit(SET_PRODUCTION_COLOR_LIST, response.data.data);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_PRODUCTION_COLOR_LIST);
          reject(error);
        });
    });
  },

  // CREATE
  saveProductionColor({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(colorResource, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  // UPDATE
  updateProductionColor({ commit }, { id, data }) {
    commit("SET_LOADING", { color: "primary" });
    const url = `${colorResource}/${id}`;

    return new Promise((resolve, reject) => {
      Axios.put(url, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
